<div class="container">
  <div class="title">
    {{ title }}
  </div>
  <form [formGroup]="gateForm" class="form">
    <div class="text-fields">
      <mat-form-field appearance="outline">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" placeholder="Nome" />
        <mat-error *ngIf="gateForm.get('name')?.hasError('required')">
          Informe o Nome da Portaria
        </mat-error>
      </mat-form-field>
    </div>

    <div class="text-fields">
      <mat-form-field appearance="outline">
        <mat-label>Endereço</mat-label>
        <input
          matInput
          formControlName="address"
          placeholder="Endereço"
          (input)="placesToAutocomplete()"
          #addressText
          autocomplete="off"
        />
        <div #gmap></div>
        <mat-error *ngIf="gateForm.get('address')?.hasError('required')">
          Informe um Endereço
        </mat-error>
        <mat-error *ngIf="gateForm.get('address')?.hasError('incorrect')">
          Selecione um endereço da lista
        </mat-error>
      </mat-form-field>
    </div>

    <div class="select-fields">
      <mat-form-field
        appearance="outline"
        class="pointer-cursor"
        (click)="openList($event, triggerResponsable)"
      >
        <mat-label>Funcionário monitor</mat-label>
        <input
          #triggerResponsable="matAutocompleteTrigger"
          type="text"
          aria-label="Funcionário monitor"
          matInput
          formControlName="responsables"
          placeholder="Funcionário monitor"
          [matAutocomplete]="autoResponsable"
          readonly
          class="pointer-cursor"
        />
        <mat-autocomplete #autoResponsable="matAutocomplete">
          <mat-option [style.display]="'none'"></mat-option>
          <app-select-simple-list
            [searchPlaceHolder]="responsablePlaceholder"
            [selectAllText]="responsableSelectAllText"
            [list]="responsables"
            (selectEvent)="handleResponsableSelect($event)"
            [hideButtons]="true"
          >
          </app-select-simple-list>
        </mat-autocomplete>
        <mat-error *ngIf="gateForm.get('responsables')?.hasError('required')">
          Selecione um Funcionário
        </mat-error>

        <span matSuffix class="material-icons" *ngIf="!autoResponsable.isOpen">
          expand_more
        </span>

        <span matSuffix class="material-icons" *ngIf="autoResponsable.isOpen">
          expand_less
        </span>
      </mat-form-field>
    </div>

    <div class="select-fields">
      <mat-form-field
        appearance="outline"
        class="pointer-cursor"
        (click)="openList($event, triggerClassroom)"
      >
        <mat-label>Turmas Liberadas</mat-label>
        <input
          #triggerClassroom="matAutocompleteTrigger"
          type="text"
          placeholder="Turmas Liberadas"
          aria-label="Turmas Liberadas"
          matInput
          formControlName="classrooms"
          [matAutocomplete]="autoClassroom"
          readonly
          class="pointer-cursor"
        />
        <mat-error *ngIf="gateForm.get('classrooms')?.hasError('required')">
          Selecione uma Turma
        </mat-error>
        <mat-autocomplete #autoClassroom="matAutocomplete">
          <mat-option [style.display]="'none'"></mat-option>
          <app-select-hierarquical-list
            [treeData]="segmentTreeData"
            [initialSelection]="selectedIdsClassrooms"
            (selectEvent)="handleSelect($event)"
            [hideButtons]="true"
          ></app-select-hierarquical-list>
        </mat-autocomplete>

        <span matSuffix class="material-icons" *ngIf="!autoClassroom.isOpen">
          expand_more
        </span>

        <span matSuffix class="material-icons" *ngIf="autoClassroom.isOpen">
          expand_less
        </span>
      </mat-form-field>
    </div>
  </form>

  <div class="buttons">
    <button mat-raised-button class="btn-cancel" (click)="closeDialog()">
      Cancelar
    </button>
    <button
      mat-raised-button
      class="btn-save"
      [disabled]="gateForm.invalid || !gateForm.dirty || saveButtonDisable"
      (click)="saveGate()"
    >
      {{ btnSaveText }}
    </button>
  </div>
</div>
